export class EnumUtil {
  static getByValue<T, V>(enumToSearch, enumValue: V): T {
    if (enumValue == null) {
      return null;
    }
    return Object.keys(enumToSearch).find((enumKey) => enumToSearch?.[enumKey] === enumValue) as unknown as T;
  }
}
